import { render, staticRenderFns } from "./UiCreateEvent.vue?vue&type=template&id=801b633c&lang=pug&"
import script from "./UiCreateEvent.vue?vue&type=script&lang=js&"
export * from "./UiCreateEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports